export enum TopicType {
  AutomatedStandard = "automated-standard",
  AutomatedAToZ  = "automated-az",
  CuratedStandard = "curated-standard",
  CuratedAToZ = "curated-az",
  CuratedCustom = "curated-custom"
}
